import React, { useEffect } from 'react';

const Awards = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero__content">
          <h1 className="page-hero__title">LLC 2026 Awards</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>/</span> Awards
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="awards-coming-soon">
            <div className="awards-coming-soon__icon">
              <svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="8" r="7"></circle>
                <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
              </svg>
            </div>
            <div className="awards-coming-soon__badge">Coming Soon</div>
            <h2 className="awards-coming-soon__title">Award Categories Being Finalized</h2>
            <p className="awards-coming-soon__text">
              We're putting the final touches on the LLC 2026 Award categories. 
              Our awards celebrate the professionals, creators, and brands making 
              significant impacts across Cameroon.
            </p>
            
            <div className="awards-coming-soon__preview">
              <div className="awards-preview-item">
                <div className="awards-preview-icon">🏆</div>
                <div className="awards-preview-text">10 Award Categories</div>
              </div>
              <div className="awards-preview-item">
                <div className="awards-preview-icon">⭐</div>
                <div className="awards-preview-text">Public Nominations</div>
              </div>
              <div className="awards-preview-item">
                <div className="awards-preview-icon">🎤</div>
                <div className="awards-preview-text">Live Ceremony at LLC 2026</div>
              </div>
            </div>

            <p className="awards-coming-soon__note">
              Categories and nomination details will be announced shortly. 
              Follow us on social media to be the first to know!
            </p>
            
            <div className="awards-coming-soon__actions">
              <a href="/contact" className="btn btn-red">Get Notified</a>
              <a href="/" className="btn btn-outline-red">Back to Home</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Awards;
